import React from "react";

const PersonalDetails = ({ player }) => {
  // Split address into parts if it contains pipe characters
  const addressParts = player.address
    ? player.address.split("|").filter((part) => part.trim() !== "")
    : [];

  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
      }}
    >
      <h3
        style={{
          fontSize: "24px",
          fontWeight: "600",
          color: "#50868f",
          marginBottom: "20px",
          paddingBottom: "10px",
          borderBottom: "2px solid #50868f",
        }}
      >
        {player.name}'s Personal Details
      </h3>

      <div
        style={{
          backgroundColor: "#fff",
          padding: "25px",
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
            gap: "20px",
          }}
        >
          <div>
            <h4
              style={{
                color: "#50868f",
                marginBottom: "15px",
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              Basic Information
            </h4>
            <div style={{ marginBottom: "12px" }}>
              <div
                style={{
                  fontSize: "14px",
                  color: "#666",
                  marginBottom: "4px",
                }}
              >
                Player ID
              </div>
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                {player.player_id}
              </div>
            </div>
            <div style={{ marginBottom: "12px" }}>
              <div
                style={{
                  fontSize: "14px",
                  color: "#666",
                  marginBottom: "4px",
                }}
              >
                Name
              </div>
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                {player.name}
              </div>
            </div>
            <div style={{ marginBottom: "12px" }}>
              <div
                style={{
                  fontSize: "14px",
                  color: "#666",
                  marginBottom: "4px",
                }}
              >
                Phone Number
              </div>
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                +{player.country_code} {player.phone}
              </div>
            </div>
            <div style={{ marginBottom: "12px" }}>
              <div
                style={{
                  fontSize: "14px",
                  color: "#666",
                  marginBottom: "4px",
                }}
              >
                Current Score
              </div>
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#50868f",
                }}
              >
                {player.score}
              </div>
            </div>
          </div>

          <div>
            <h4
              style={{
                color: "#50868f",
                marginBottom: "15px",
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              Address
            </h4>
            {addressParts.length > 0 ? (
              <div
                style={{
                  backgroundColor: "#f9f9f9",
                  padding: "15px",
                  borderRadius: "6px",
                  borderLeft: "3px solid #50868f",
                }}
              >
                {addressParts.map((part, index) => (
                  <div
                    key={index}
                    style={{
                      marginBottom:
                        index !== addressParts.length - 1 ? "8px" : "0",
                      fontSize: "15px",
                    }}
                  >
                    {part}
                  </div>
                ))}
              </div>
            ) : (
              <div
                style={{
                  color: "#999",
                  fontStyle: "italic",
                }}
              >
                No address provided
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalDetails;
